import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFarmOrganicFertilizerProduction } from "services";

import { DELETE_FARM_ORGANIC_FERTILIZER_PRODUCTION, GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, GET_FARM_ORGANIC_FERTILIZER_PRODUCTION } from "consts";

export const useDeleteFarmOrganicFertilizerProduction = ({ farmId, year: _year }: { farmId: string; year: number }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId],
    mutationFn: deleteFarmOrganicFertilizerProduction,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_ADMIN_FARM_ORGANIC_FERTILIZER_PRODUCTION, farmId] });
    },
  });
};
